<script lang="ts">
  import { auth } from '../lib/firebase/auth.svelte';

  /**
   * Page de connexion admin dédiée, servie sur /login (non référencée).
   * L'atelier est 100 % admin : aucun compte client (le suivi de commande et
   * les comptes vivent sur Shopify). Une fois l'accès admin confirmé côté
   * serveur (allowlist), on redirige vers le back-office.
   */

  // Redirige vers l'admin dès que l'accès est confirmé.
  $effect(() => {
    if (auth.user && auth.isAdmin) {
      window.location.href = '/#/admin';
    }
  });

  async function signIn(): Promise<void> {
    await auth.signInWithGoogle();
  }
</script>

<main class="login">
  <div class="login__card">
    <a href="/" class="login__brand">Perleur</a>

    {#if !auth.configured}
      <p class="alert alert--warning">Authentification indisponible sur cet environnement.</p>
    {:else if auth.loading}
      <p class="login__muted">Chargement…</p>
    {:else if !auth.user}
      <h1 class="login__title">Administration</h1>
      <p class="login__muted">Connexion réservée à l'équipe Perleur.</p>
      <button type="button" class="btn btn--primary btn--lg btn--full" onclick={signIn}>
        Continuer avec Google
      </button>
      {#if auth.emulated}
        <!-- DEV/TEST (émulateur Firebase uniquement) : connexion admin factice,
             sans Google réel. Jamais présent en prod (le flag n'y est pas posé). -->
        <button type="button" class="btn btn--ghost btn--full" onclick={() => auth.signInTestAdmin()}>
          🧪 Connexion admin de test (émulateur)
        </button>
      {/if}
      {#if auth.error}<p class="alert alert--error">{auth.error}</p>{/if}
    {:else if auth.roleLoading}
      <p class="login__muted">Vérification de l'accès…</p>
    {:else if !auth.isAdmin}
      <h1 class="login__title">Accès non autorisé</h1>
      <p class="login__muted">
        Le compte <strong>{auth.user.email}</strong> n'est pas autorisé à accéder à
        l'administration.
      </p>
      <button type="button" class="btn btn--ghost btn--full" onclick={() => auth.signOut()}>
        Changer de compte
      </button>
    {:else}
      <p class="login__muted">Connecté. Redirection…</p>
    {/if}
  </div>
</main>

<style>
  .login {
    min-height: 100dvh;
    display: grid;
    place-items: center;
    padding: var(--space-4);
    background: var(--color-background);
  }
  .login__card {
    width: 100%;
    max-width: 24rem;
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    padding: var(--space-6);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    background: var(--color-surface);
    text-align: center;
  }
  .login__brand {
    font-family: var(--font-heading);
    font-size: var(--text-h3);
    color: var(--color-primary);
    text-decoration: none;
    margin-bottom: var(--space-2);
  }
  .login__title {
    font-size: var(--text-h3);
    margin: 0;
  }
  .login__muted {
    color: var(--color-text-muted);
    font-size: var(--text-small);
    margin: 0;
  }
</style>
